module.exports = __webpack_public_path__ + "img/分组 33.3db37969.png";